import { ISlideInitialData, ISlideInitialDataService } from '../interfaces/slide-initial-data-service.interface';

export class SlideInitialDataService implements ISlideInitialDataService {
    private data: ISlideInitialData | null;

    public constructor(data: ISlideInitialData) {
        this.data = data;
    }

    public setData(data: ISlideInitialData) {
        this.data = data;
    }

    public consume(): ISlideInitialData {
        const { data } = this;
        if (!data) {
            throw new Error('No initial data or initial data has been consumed');
        }

        this.data = null;
        return data;
    }
}
